export default __webpack_public_path__ + "static/media/GreySurvey.8714f48e.svg";